import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './Home';
import SampleProjects from './sample_projects';
import Contact from './contact';
import About from './About';
import VideoGallery from './video_gallery';
import Detail from './detail';
import CityBase from './city_base';
import WardrobeCalculator from './wardrobe_calculator';
import DesignIdeas from './design_ideas';
import Checked from './checked';
import Admin from './Admin';
import Login from './Login';
import Register from './Register';
import Admininroute from './Admininroute';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import Blogin from './blogin';
import Kitchen from './kitchen';

import './App.css';



function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />}/>
      <Route path="/sample_projects" element={<SampleProjects />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/about" element={<About />} />
       <Route path="/video_gallery" element={<VideoGallery/>}/>
        <Route path="/detail/:id" element={<Detail/>}/>
        <Route path="/city_base" element={<CityBase/>}/>
         <Route path="/kitchen" element={<Kitchen/>}/>

        <Route path="/wardrobe_calculator" element={<WardrobeCalculator/>}/>
        <Route path="/design_ideas" element={<DesignIdeas/>}/>
         <Route path="/checked" element={<Checked/>}/>
         <Route path="/Login" element={<Login/>}/>
          <Route path="/Login" element={<Login/>}/>
          <Route path="/blogin" element={<Blogin/>}/>

         <Route path="/Register" element={<Register/>}/>
      <Route path="/login" element={<Login/>}/>
      <Route path="/register" element={<Register/>}/>
      <Route path="/forgot-password" element={<ForgotPassword/>}/>
      <Route path="/reset-password/:token" element={<ResetPassword/>}/>
      <Route
        path="/admin/*"
        element={
           <Admininroute><Admin/></Admininroute>
        }
      />
    </Routes>
  );
}

export default App;